import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { DetalleBienCulturalService } from '../detalle-bien-cultural.service';
import { PutDetalleBienes } from './models/put-detalle-bienes.model';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Tipologia } from 'app/models/tipologias.model';
import { environment as env } from 'environments/environments';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'info-principal-bien-cultural',
    templateUrl: 'info-principal.component.html',
    imports:[
        FormsModule, MatSelectModule,CommonModule
    ]
})

export class InfoPrincipalBienCulturalComponent implements OnInit {
    @Input() ficha:FichaRegistro
    detalle:PutDetalleBienes
    tipoPropiedad:Tipologia[] = []
    tipoPoseedor: Tipologia[] = []
    tipologiaPadreIdTipoPoseedor:number= 161072;
    ninguna: Tipologia = {
        tipologiaId: 160000,
        tipologiaPadreId: 0,
        descripcion: '',
        valor1: '',
        valor2: '',
        valor3: ''
    };



    constructor(private detalleBienService:DetalleBienCulturalService) { 
        // Inicializa el detalle con los datos de la ficha
        this.detalle = {
            descripcion: this.ficha?.descripcion,
            tipoPropiedad: {} as Tipologia
        } as PutDetalleBienes;

    }

    async ngOnInit() {
        this.tipoPropiedad = await this.getTipoPropiedad();
        this.tipoPoseedor = await this.getTipoPoseedor();

        this.actualizarDetalleDesdeFicha();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ficha'] && !changes['ficha'].firstChange) {
        this.actualizarDetalleDesdeFicha();
        }
    }

    private actualizarDetalleDesdeFicha(): void {
        if (!this.ficha) return;

        const tipoPropiedadSeleccionado = this.tipoPropiedad.find(
        tipo => tipo.tipologiaId === this.ficha.tipoPropiedad?.tipologiaId
        );

        const tipoPoseedorSeleccionado = this.tipoPoseedor.find(
        tipo => tipo.tipologiaId === this.ficha.tipoPoseedor?.tipologiaId
        ) || this.ninguna;

        this.detalle = {
            descripcion: this.ficha.descripcion,
            tipoPropiedad: tipoPropiedadSeleccionado || {} as Tipologia,
            tipoPoseedor: tipoPoseedorSeleccionado || {} as Tipologia,
            anotaciones: this.ficha.anotaciones || '',
            observaciones: this.ficha.observaciones || '',
            decretoAcuerdo: this.ficha.decretoAcuerdo || ''
        } as PutDetalleBienes;
    }


    putDetalleBienCultural(){
        this.detalleBienService.putDetalleBienCultural(this.ficha.bienCulturalUuid, this.detalle)
            .then(response=>{
                this.detalleBienService.getBitacoraBienes(this.ficha.bienCulturalUuid)
                this.detalleBienService.getFichaRegistro(this.ficha.bienCulturalUuid)
        })
    }
    
    getTipoPropiedad(): Promise<Tipologia[]> {
        return this.detalleBienService.getTipologias(env.TIPOLOGIA_ID_TIPO_PROPIEDAD);
    }

    getTipoPoseedor(): Promise<Tipologia[]> {
        return this.detalleBienService.getTipologias(this.tipologiaPadreIdTipoPoseedor);
    }

 
  
}